// Dizzplace - arkusz "Podaj ilosc" na telefonie (Figma 1050:9074 / 1050:9117).
//
// Na telefonie przycisk "Dodaj do koszyka" NIE wklada od razu do koszyka:
// otwiera ten arkusz, a dopiero przycisk w arkuszu wysyla formularz. Powyzej
// 990 px arkusz nie istnieje - tam cala kolumna zakupu jest na ekranie.
//
// Kalkulator nie jest kopiowany. Ten sam element przenosimy z kolumny zakupu
// do arkusza na czas otwarcia i oddajemy na miejsce po zamknieciu; wraca tam,
// gdzie stal, bo pozycje wyjsciowa trzyma komentarz-kotwica.

(() => {
  const TELEFON = '(max-width: 989px)';

  class QuantitySheet extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.panel = this.querySelector('.qty-sheet__panel');
      // UWAGA: `slot` to wlasciwosc wlasna HTMLElement (napis dla shadow DOM),
      // wiec pole musi nazywac sie inaczej - przypisanie elementu do `this.gniazdo`
      // zamienia go w tekst i `appendChild` przestaje istniec.
      this.gniazdo = this.querySelector('[data-calculator-slot]');
      this.kalkulator = document.querySelector('[data-calculator]');
      if (this.kalkulator && this.kalkulator.parentElement) {
        this.kotwica = document.createComment('kalkulator');
        this.kalkulator.parentElement.insertBefore(this.kotwica, this.kalkulator);
      }

      this.addEventListener('click', (zdarzenie) => {
        if (zdarzenie.target.closest('[data-qty-sheet-close]')) this.zamknij();
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });

      // Przyciski zakupu przejmujemy w fazie PRZECHWYTYWANIA, zanim formularz
      // zdazy wyslac zdarzenie `submit` przechwytywane przez szuflade koszyka.
      document.addEventListener(
        'click',
        (zdarzenie) => {
          if (!window.matchMedia(TELEFON).matches) return;

          const przycisk = zdarzenie.target.closest('.product-cta .button-cta, .sticky-atc__button');
          if (!przycisk || przycisk.disabled) return;
          if (this.contains(przycisk)) return;
          // Probka tego wzoru i odnosniki (np. do wszystkich probek) to nie
          // zakup plyty - arkusz ilosci otwieral sie zamiast nich.
          if (przycisk.matches('a, [data-quick-sample-add], [data-quick-sample-proxy]')) return;

          zdarzenie.preventDefault();
          zdarzenie.stopPropagation();
          this.otworz();
        },
        true
      );

      // Licznik w arkuszu jest lustrem pola z formularza zakupu: przy otwarciu
      // bierze jego wartosc, a kazda zmiana wraca do formularza (razem ze
      // zdarzeniem, ktorego slucha cena w przycisku).
      this.pole = this.querySelector('[data-qty-lustro]');
      this.zrodlo = document.querySelector('.product-buy__form [data-stepper-input]');
      if (this.pole && this.zrodlo) {
        this.pole.addEventListener('change', () => {
          const ile = Math.max(1, Number(this.pole.value) || 1);
          this.pole.value = String(ile);
          if (Number(this.zrodlo.value) === ile) return;
          this.zrodlo.value = String(ile);
          this.zrodlo.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.pole.addEventListener('input', () => this.pole.dispatchEvent(new Event('change', { bubbles: true })));
      }

      // Kalkulator w dolnym menu otwiera TEN arkusz z rozwinietym kalkulatorem -
      // to jedno miejsce, w ktorym klient liczy plyty i podaje ilosc.
      document.addEventListener('click', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-bottom-calculator]')) return;
        zdarzenie.preventDefault();
        this.otworz(true);
      });

      // Zakup z arkusza: zamykamy go od razu, a koszyk otwiera juz szuflada.
      this.podepnijPrzeciaganieUchwytu();

      const wyslij = this.querySelector('.qty-sheet__submit');
      if (wyslij) wyslij.addEventListener('click', () => window.setTimeout(() => this.zamknij(), 0));
    }

    /* Przeciagniecie uchwytu w dol zamyka arkusz - ten sam gest co w szufladzie
       koszyka i w menu mobilnym. Ponizej progu panel wraca na miejsce. */
    podepnijPrzeciaganieUchwytu() {
      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        if (!przeciaga || !this.panel) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        this.panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        if (this.panel) {
          this.panel.classList.remove('qty-sheet__panel--przeciagane');
          this.panel.style.transform = '';
        }
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      this.addEventListener('pointerdown', (zdarzenie) => {
        if (!zdarzenie.target.closest('.qty-sheet__handle') || !this.panel) return;
        przeciaga = true;
        startY = zdarzenie.clientY;
        deltaY = 0;
        this.panel.classList.add('qty-sheet__panel--przeciagane');
        this.setPointerCapture(zdarzenie.pointerId);
      });
      this.addEventListener('pointermove', naRuch);
      this.addEventListener('pointerup', naKoniec);
      this.addEventListener('pointercancel', naKoniec);
    }

    otworz(zKalkulatorem) {
      if (this.pole && this.zrodlo) this.pole.value = String(Math.max(1, Number(this.zrodlo.value) || 1));
      this.przejmijKalkulator();
      if (zKalkulatorem && this.kalkulator) this.kalkulator.open = true;
      this.hidden = false;
      window.dizzBlokadaTla?.zablokuj(this.panel || this);
      window.requestAnimationFrame(() => {
        this.classList.add('qty-sheet--otwarty');
        if (this.panel) this.panel.focus();
      });
    }

    zamknij() {
      if (this.hidden) return;
      this.classList.remove('qty-sheet--otwarty');
      window.dizzBlokadaTla?.odblokuj();

      const koniec = () => {
        this.hidden = true;
        this.oddajKalkulator();
      };

      if (this.panel) {
        this.panel.addEventListener('transitionend', koniec, { once: true });
        window.setTimeout(koniec, 400);
      } else {
        koniec();
      }
    }

    przejmijKalkulator() {
      if (!this.kalkulator || !this.gniazdo || this.kalkulator.parentElement === this.gniazdo) return;
      // W arkuszu kalkulator jest zwinieta podpowiedzia, a nie otwartym polem.
      this.kalkulator.open = false;
      this.gniazdo.appendChild(this.kalkulator);
    }

    oddajKalkulator() {
      if (!this.kalkulator || !this.kotwica || !this.kotwica.parentNode) return;
      if (this.kalkulator.parentElement === this.gniazdo) {
        // Wraca zwiniety - tak samo, jak stoi na stronie przed pierwszym dotknieciem.
        this.kalkulator.open = false;
        this.kotwica.parentNode.insertBefore(this.kalkulator, this.kotwica);
      }
    }
  }

  if (!customElements.get('quantity-sheet')) {
    customElements.define('quantity-sheet', QuantitySheet);
  }
})();
